import React, { useState } from "react";
import "./scheduleLeave.css";
import strings from "../../utils/property-file/manageLeave.json";
import "../color.css";
import SelectEmpLeave from "./Leave/scheduleLeave/scheduleEmpLeave";
import { useNavigate } from "react-router-dom";
import constants from "../../utils/constants";

export default function ScheduleLeaves() {
  const [activeLeaveType, setActiveLeaveType] = useState(
    "all-btn-leave-type-active-btn "
  );
  const [activeWFHType, setActiveWFHType] = useState(
    "all-btn-leave-type "
  );
  const selectEmpActive = true;
  const nav = useNavigate();
  const [fetchLeaveType , setFetchLeaveType] = useState(strings.leaveLabel)

  const handleClickWorkFromHome = () =>{
    setActiveLeaveType("all-btn-leave-type")
    setActiveWFHType("all-btn-wfh-type-active-btn")
    setFetchLeaveType("WFH")
  }
  const handleClickLeave = () =>{
    setActiveLeaveType("all-btn-leave-type-active-btn")
    setActiveWFHType("all-btn-leave-type");
    setFetchLeaveType(strings.leaveLabel)
  }

  return (
    <>
      <div className="schedule-leave-container">
        <div className="schedule-leave-sub-container">
          <div className="back-arrow-heading-icon">
            <div
              className="back-icon-schedule-leave"
              onClick={() => {
                nav(constants.navigationLink.backPage);
              }}
            >
              <i className="ri-arrow-left-line"></i>
            </div>
            <div className="schedule-leave-heading">
              {strings.scheduleLeave}
            </div>
          </div>
          <div className="button-container-leave-type">
            <div className="leave-type-btn-container">
              <button className={activeLeaveType}  onClick={handleClickLeave}>
                {strings.leaveLabel}
              </button>
            </div>
            <div className="leave-type-btn-container">
              <button className={activeWFHType} onClick={handleClickWorkFromHome}>{strings.wfhLabel}</button>
            </div>
          </div>
          <div className="select-emp-name">
            {selectEmpActive && <SelectEmpLeave type={fetchLeaveType} />}
          </div>
        </div>
      </div>
    </>
  );
}
